import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const postContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const postCatalogueLead = (payload) => api.post("/eisg/catalogue", payload).then((r) => r.data);
export const postRegistration = (payload) => api.post("/eisg/register", payload).then((r) => r.data);
export const catalogueDownloadUrl = () => `${API}/eisg/catalogue/download`;
